/****************************************************************************************************
 * COMPONENT: BASIC PORTABLE TEXT
 * --------------------------------------------------------------------------------------------------
 * This component is a re-usable portable text component that implements the spacing set
 * by the CMS and stored in the store. This component is used in the Section component,
 * Block component, or any other component where you want to render portable text that
 * uses the spacing set in the CMS.
 * *************************************************************************************************/
import React from 'react';
import { Stack } from '@mui/material';
import { PortableText } from '@portabletext/react';
import { DefaultSerializer } from 'src/components';
import { useStoreV2 } from 'src/store/StoreV2';

interface BasicPortableTextProps {
  content: any;
}

const BasicPortableText = ({ content }: BasicPortableTextProps) => {
  {
    /********************************************************************************
     * * Store V2
     * ------------------------------------------------------------------------------
     * Content Spacing for portable text is configured in the CMS. This layout data
     * is stored in the store and can be accessed by subscribing to the store.
     * ******************************************************************************/
  }

  const contentSpacing = useStoreV2().layout?.contentSpacing ?? ['10px'];

  return (
    <Stack      
      spacing={contentSpacing}
      
      display={'flex'}
      flexDirection={'column'}
      
      // justifyContent={'center'}
      // alignContent={'center'}
      // MODE
      // column: Aligns items along the horizontal axis
      // row: Aligns items along the vertical axis
      alignItems={'flex-start'}
    >
      <PortableText value={content} components={DefaultSerializer} />
    </Stack>
  );
};

export default BasicPortableText;
